
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class POSOrderDialog extends _Ext.TransDialog<POSOrderRow, any> {

        protected getFormKey() { return POSOrderForm.formKey; }
        protected getIdProperty() { return POSOrderRow.idProperty; }
        protected getLocalTextPrefix() { return POSOrderRow.localTextPrefix; }
        protected getNameProperty() { return POSOrderRow.nameProperty; }
        protected getService() { return POSOrderService.baseUrl; }
        protected getDeletePermission() { return POSOrderRow.deletePermission; }
        protected getInsertPermission() { return POSOrderRow.insertPermission; }
        protected getUpdatePermission() { return POSOrderRow.updatePermission; }
        protected useViewMode() { return true; }

        public form = new POSOrderForm(this.idPrefix);
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public useMF: boolean; 
        contractTotals: string; 
        TaxArray: any[]; 

        constructor() {
            super();
            //Make grid full width
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initItemEditor(this, this.form.ItemDetails, Config);

            q.initItemEditor(this, this.form.ReceiptDetails);
            //Make grid full width
            q.hideEditorLabel(this.form.ItemDetails);
            q.hideEditorLabel(this.form.ItemDetails);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.AdditionalCharges);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.MF);
            q.setTextRightAlign(this.form.ReceiptAmount);
            q.setGridEditorHeight(this.form.ItemDetails, 300);
            q.hideEditorLabel(this.form.ReceiptDetails);
            q.SetSix12Column(this.form.ReceiptDetails);

            q.hideImageToolbar(this.form.ProductItemImage);
            q.hideEditorLabel(this.form.ProductItemImage);
            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategoryFourColumn(this.form.BillNo);
            q.SetCategoryTwoColumn(this.form.ProductItemImage);
            //q.SetCategoryFourColumn(this.form.BillingAddress);
            //q.SetCategoryTwoColumn(this.form.VoucherTypeId);
            //q.SetCategoryFourColumn(this.form.ShippingAddress);
            q.SetCategoryFullWidth(this.form.ItemDetails);
            q.SetSix12Column(this.form.FinancialYearId);
            q.SetCategoryTwoColumn(this.form.Pieces);
            q.SetCategoryFourColumn(this.form.NetAmount);
            q.SetCategoryFullWidth(this.form.Remark);

            q.hideEditorCategoryLabel(this.form.TransDate.element);
            q.hideEditorCategoryLabel(this.form.ProductItemImage.element);
            //q.hideEditorCategoryLabel(this.form.VoucherTypeId.element);
            q.hideEditorCategoryLabel(this.form.BillNo.element);
            q.hideEditorCategoryLabel(this.form.ItemDetails.element);
            q.hideEditorCategoryLabel(this.form.ReceiptDetails.element);
            q.hideEditorCategoryLabel(this.form.Pieces.element);
            q.hideEditorCategoryLabel(this.form.NetAmount.element);
            q.hideEditorCategoryLabel(this.form.Remark.element);

            q.hideCaption(this.form.CustomerName);

            // **** Get Party Details using PartyID **** 
            this.form.POSCustomerId.changeSelect2(e => {
                var CUSTOMERID = this.form.POSCustomerId.value
                if (this.form.POSCustomerId.value != null && this.form.POSCustomerId.value != "") {
                    var customerid = parseInt(this.form.POSCustomerId.value);
                    let PartyDetails;
                    OMS.PosCustomerMasterService.Retrieve({
                        EntityId: parseInt(this.form.POSCustomerId.value)
                    }, response => {
                        PartyDetails = response.Entity;
                    }, { async: false });
                    var firstname = PartyDetails.FirstName == undefined ? "" : PartyDetails.FirstName;
                    var lastname = PartyDetails.LastName == undefined ? "" : PartyDetails.LastName;
                    this.form.CustomerName.value = firstname + " " + lastname;
                    this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value.toString());
                    this.form.GrossAmount.value = 0;
                }

            });
            this.form.ItemDetails.slickGrid.setOptions({ forceFitColumns: true });



            // **** Calculate Net,Gross Amount, Discount and Tax from Item Details and show on form ****
         
            var Items: any;
            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => {
                Items = this.form.ItemDetails.getItems();
                var TotalItems = this.form.ItemDetails.getTotalRows();
                this.CalculateAmountandTax(Items, TotalItems);
                if (Items.length > 0)
                    q.showAndDisableField(this.form.MF);
                else {
                    if (this.useMF)
                        q.showAndSetRequiredField(this.form.MF);
                }
            });

            (this.form.ReceiptDetails.view as any).onRowCountChanged.subscribe(() => {
                this.CalculateTotals();
            });

            this.form.GrossAmount.addValidationRule(this.uniqueName, e => {
                //Validate that the knock off value is not less than or greater than total Amount
                if (this.form.ItemDetails.getItems().length == 0) {
                    Q.alert("There are no Items added in transaction. Can not save!!")
                    return "";
                }
            });

            this.validateForm();
        }

        public CalculateAmountandTax(Items: any, TotalItems: number) {
            if (!this.isViewMode()) {

                var codearray = [];
                var amtarray = [];
                var ItemTotal = 0;
                var ntamt = 0; var gramt = 0; var disc = 0; var pcs = 0; var nwt = 0; var wt = 0;

                //Items.forEach(function (x)
                for (var x of Items) {
                    ntamt += x.NetAmount || 0;
                    gramt += x.GrossAmount || 0;
                    disc += x.Discount || 0;
                    pcs += x.Pieces || 0;
                    wt += x.Weight || 0;
                    nwt += x.NetWeight || 0;

                    if (x.HSN != null || x.HSN != "NA") {
                        var temp = false;
                        for (let i = 0; i < codearray.length; i++) {
                            if (codearray[i] == x.HSN) {
                                amtarray[i] += x.GrossAmount || 0;
                                temp = true;
                            }
                        }

                        if (!temp) {
                            codearray.push(x.HSN);
                            amtarray.push(x.GrossAmount);
                        }
                    }
                    ItemTotal++;
                };

                this.form.NetAmount.value = gramt;
                this.form.Discount.value = disc;

                var TaxAmount = 0;

                var TaxApplicable = OMS.VoucherMasterRow.getLookup().items.filter(x => x.VoucherTypeId == this.form.VoucherTypeId.value)[0].IsTaxApplicable;

                if (ItemTotal == TotalItems && TaxApplicable) {

                    //this.form.TaxAmount.value = TaxAmount;
                    this.form.GrossAmount.value = gramt + TaxAmount;
                    this.form.Pieces.value = pcs;
                    this.form.Weight.value = wt;
                    this.form.NetWeight.value = nwt;
                }
                else {
                    this.form.GrossAmount.value = gramt;
                    this.form.Pieces.value = pcs;
                    this.form.Weight.value = wt;
                    this.form.NetWeight.value = nwt;
                }

                this.form.ItemDetails.render;
            }
        }

        public CalculateTotals() {

            var Receipts: any;
            Receipts = this.form.ReceiptDetails.getItems();
            var ItemTotal = 0;
        var TotalItems = this.form.ReceiptDetails.getItems().length;
        if (ItemTotal > 0) {
            ItemTotal = 0;
        }

        if (Receipts.length == TotalItems) {
            var totalamount = 0;
            for (var i = 0; i < Receipts.length; i++) {
                totalamount += parseFloat(Receipts[i].Amount);

            }
            this.form.ReceiptAmount.value = totalamount;
        }}
        protected onDialogOpen() {
            super.onDialogOpen();
              
            var useMF = q.ToBool(GetConfigValue(1022));
            this.useMF = useMF;
            if (useMF) {
                q.showAndSetRequiredField(this.form.MF);
            } else {
                q.hideField(this.form.MF);
            }
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            let companyDetails = OMS.CompanyRow.getLookup().itemById[this.form.CompanyId.value];
            this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value.toString());
            this.RateListId = companyDetails.SPriceListId == null ? 0 : companyDetails.SPriceListId;
            this.LaborListId = companyDetails.SLabourListId == null ? 0 : companyDetails.SLabourListId;
            this.StoneMarkup = companyDetails.SMarkup == null ? 0 : companyDetails.SMarkup;
            //this.StoneDiscount = companyDetails.== null ? 0 : companyDetails.StnAddDisc;
            this.LaborMarkup = companyDetails.SLMarkup == null ? 0 : companyDetails.SLMarkup;
            if (this.form.POSCustomerId.value != "") {

                //Serenity.EditorUtils.setReadOnly(this.form.ShippingCity, false);

                //Serenity.EditorUtils.setReadOnly(this.form.ShippingState, false);
                //var address = this.entity.AddressDetails;
                //for (var i = 0; i < address.length; i++) {
                //    if (address[i].Type == 47) {
                //        this.form.ShippingState.cascadeField = "CountryId";
                //        this.form.ShippingState.cascadeValue = address[i].Country.toString();
                //        this.form.ShippingCity.cascadeField = "StateId";
                //        this.form.ShippingCity.cascadeValue = address[i].State == null ? 0 : address[i].State.toString();
                //        this.form.ShippingAddress.value = address[i].Address1.toString();
                //        this.form.ShippingCity.value = address[i].City == null ? "0" : address[i].City.toString();
                //        this.form.ShippingCityName.value = address[i].City.toString();
                //        this.form.ShippingState.value = address[i].State == null ? "0" : address[i].State.toString();

                //        this.form.ShippingStateName.value = address[i].StateName;
                //        this.form.ShippingCountry.value = address[i].Country == null ? "0" : address[i].Country.toString();
                //        this.form.ShippingCountryName.value = address[i].CountryName.toString();
                //        this.form.ShippingPincode.value = address[i].Pincode.toString();
                //    } else if (address[i].Type == 48) {
                //        this.form.BillingAddress.value = address[i].Address1.toString();
                //        this.form.BillingCity.value = address[i].City;
                //        this.form.BillingCityName.value = address[i].City.toString();
                //        this.form.BillingState.value = address[i].State != null ? address[i].State : 0;
                //        this.form.BillingStateName.value = address[i].StateName;
                //        this.form.BillingCountry.value = address[i].Country;
                //        this.form.BillingCountryName.value = address[i].CountryName.toString();
                //        this.form.BillingPin.value = address[i].Pincode.toString();
                //    }
                //}
            }

        }


        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();
            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");
            var oldDeleteClick = btnDelete.onClick;
            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };

            //Edit Click Override
            var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            var oldEditClick = btnEdit.onClick;
            btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };

            //Export PDF Button
            btns.push(TabAurous.Common.ReportHelper.createToolButton({
                title: 'Print',
                cssClass: 'export-pdf-button',
                icon: 'fa fa-print text-blue',
                reportKey: 'Retail.OrderVoucher',
                getParams: () => ({
                    TransID: this.get_entityId()
                })
            }));


            return btns;
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.ProductName != null || refid.ProductName != "") {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                Serenity.EditorUtils.setReadonly(this.form.ItemDetails.element, false);
                this.form.ItemDetails.canUpdate = 1;
                if (!self.isEditMode())
                    return;
                self.editClicked = true;
                self.updateInterface();
                self.updateTitle();
            }
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                POSOrderService.Delete(
                    {
                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            }

        }

        validateBeforeSave() {
            let Isvalid = super.validateBeforeSave();
            Isvalid = ValidateTransaction(this.form.ItemDetails.getItems(), this.form.Pieces.value, this.form.Weight.value);
            return Isvalid;
        }


        validateEntity(row: Retail.POSOrderRow, id: number) {

            if (row.ItemDetails.length == 0) {
                Q.alert("No Items added, At least add one entry. Can not Save! ")
                return false;
            }
            var items = this.form.ItemDetails.getItems();
            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                item.RefVoucherId = item.RefVoucherId == null ? 0 : item.RefVoucherId;
                item.RefTransId = item.RefTransId == null ? 0 : item.RefTransId;
                item.RefTransItemId = item.RefTransItemId == null ? 0 : item.RefTransItemId;
                item.RefNo = item.RefNo == undefined ? "0" : item.RefNo;
                item.DepartmentId = item.DepartmentId == null ? 0 : item.DepartmentId;
                item.MetalAmount = item.MetalAmount == null ? 0 : item.MetalAmount;
                item.DiamondAmount = item.DiamondAmount == null ? 0 : item.DiamondAmount;
                item.StoneAmount = item.StoneAmount == null ? 0 : item.StoneAmount;
                item.OtherAmount = item.OtherAmount == undefined ? 0 : item.OtherAmount;
            }
        }
     }
}